








import Vue from 'vue'
import { BulletedTextElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'BulletedTextEl',
  props: {
    templateItemData: {
      type: Object as () => BulletedTextElInterface,
      required: true
    }
  }
})
